import type { SVGProps } from 'react';

const SvgAssetDelete = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 3H6C4.35 3 3 4.35 3 6v8c0 1.65 1.35 3 3 3h5c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1-.45-1-1v-.5l3.03-2.28 2.41 1.61c.36.24.84.22 1.18-.05l4.39-3.52 3.38 2.54s.07.03.1.05c.06.04.12.07.19.09s.13.03.2.04c.04 0 .07.02.11.02.02 0 .04-.01.07-.01.07 0 .14-.02.2-.04s.12-.03.17-.06c.06-.03.1-.07.15-.1.06-.04.11-.08.15-.14.02-.02.04-.03.05-.05.02-.03.03-.07.05-.1.03-.06.07-.12.09-.18s.03-.13.04-.2c0-.04.02-.07.02-.11v-5c0-1.65-1.35-3-3-3zm-2.62 4.22-4.43 3.54-2.39-1.59a.99.99 0 0 0-1.15.03L5.01 11V6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v3l-2.4-1.8a.99.99 0 0 0-1.22.02z"
    />
    <path
      fill="currentcolor"
      d="M10.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m10.21 5.29a.996.996 0 0 0-1.41 0l-1.79 1.79-1.79-1.79a.996.996 0 1 0-1.41 1.41l1.79 1.79-1.79 1.79a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l1.79-1.79 1.79 1.79c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-1.79-1.79 1.79-1.79a.996.996 0 0 0 0-1.41z"
    />
  </svg>
);
export default SvgAssetDelete;
